import { DayOfWeek, StaffingUnit, StaffingUnitType, User } from '@shared/models';

import { fromDayString, toDate } from './time.utils';

export function isUserAssignableInWeek(user: User, week: string): boolean {
  return (
    toDate(user.startsAt) <= fromDayString(week) &&
    (!user.endsAt || toDate(user.endsAt) >= fromDayString(week)) &&
    user.isAssignableEmployee &&
    !user.isRemoved
  );
}

export function isUserAssignedInOtherStaffings(
  staffingUnits: StaffingUnit[],
  currentStaffingUnitId: string | undefined,
  userId: string,
  week: string,
  day: DayOfWeek
): boolean {
  return getUserAssignedStaffingUnits(staffingUnits, currentStaffingUnitId, userId, week, day).length > 0;
}

export function getUserAssignedStaffingUnits(
  staffingUnits: StaffingUnit[],
  currentStaffingUnitId: string | undefined,
  userId: string,
  week: string,
  day?: DayOfWeek
): StaffingUnit[] {
  return staffingUnits
    .filter((unit) => unit.id !== currentStaffingUnitId && unit.type !== StaffingUnitType.Unassigned)
    .filter((unit) =>
      unit.staffingUnitsInTime.some(
        (item) =>
          item.day === week &&
          item.assignedEmployees.some(
            (employee) => employee.userId === userId && (day ? employee.days?.includes(day) : employee.days?.length)
          )
      )
    );
}
